(function () {
  'use strict';

  if (window.__vpStorefrontFixesLoaded) return;
  window.__vpStorefrontFixesLoaded = true;

  var ZEUS_SHOT_VARIANT_ID = 52346918601005;
  var OFFER_COLLECTION_PATH = '/collections/selected-10ml-nic-salts-10-for-15';
  var SUPPORT_EMAIL = 'support@vapersplace.co.uk';
  var SUPPORT_PHONE = '01536 269622';
  var styleId = 'vp-storefront-fixes-styles';
  var enhanceTimer = 0;
  var shotSyncTimer = 0;
  var shotSyncRunning = false;
  var shotSyncPending = false;
  var idCounter = 0;

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function pathWithoutTrailingSlash() {
    return window.location.pathname.replace(/\/$/, '') || '/';
  }

  function isVisible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && !!(
      element.offsetWidth || element.offsetHeight || element.getClientRects().length
    );
  }

  function isRendered(element) {
    if (!element || element.hidden) return false;
    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && !!(
      element.offsetWidth || element.offsetHeight || element.getClientRects().length
    );
  }

  function uniqueId(prefix) {
    idCounter += 1;
    return prefix + '-' + idCounter;
  }

  function replaceTag(element, tagName) {
    if (!element || element.tagName.toLowerCase() === tagName.toLowerCase()) return element;
    var replacement = document.createElement(tagName);
    Array.prototype.forEach.call(element.attributes, function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    while (element.firstChild) replacement.appendChild(element.firstChild);
    if (element.parentNode) element.parentNode.replaceChild(replacement, element);
    return replacement;
  }

  function installStyles() {
    if (document.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '.vp-full-description,.vp-offer-terms,.vp-checkout-assurance{box-sizing:border-box;}',
      '.vp-full-description{clear:both;margin:2rem auto;padding:1.25rem;max-width:1200px;}',
      '.vp-full-description>h2{margin-top:0;}',
      '.vp-full-description img{max-width:100%;height:auto;}',
      '.vp-offer-terms{margin:1rem 0 1.5rem;padding:1rem;border:1px solid rgba(0,0,0,.12);border-radius:.35rem;background:rgba(0,0,0,.025);}',
      '.vp-offer-terms p,.vp-checkout-assurance p{margin:.25rem 0;}',
      '.vp-checkout-assurance{margin:1rem 0;padding:1rem;border:1px solid rgba(0,0,0,.12);border-radius:.35rem;background:rgba(0,0,0,.025);}',
      '[role="dialog"][aria-modal="true"] :focus-visible{outline:3px solid currentColor;outline-offset:3px;}',
      '@media (max-width:1024px){body.vp-offer-collection .yv-product-options .Sd_addProduct.vp-single-variant-quick-add{display:flex!important;visibility:visible!important;opacity:1!important;transform:scale(1)!important;pointer-events:auto!important;touch-action:manipulation;}}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function initialiseNicotineSelect(select) {
    if (!select || select.tagName !== 'SELECT') return;

    if (select.getAttribute('data-vp-listener-attached') !== 'true') {
      select.setAttribute('data-vp-listener-attached', 'true');
      select.addEventListener('change', function () {
        if (select.getAttribute('data-vp-programmatic-change') !== 'true') {
          select.setAttribute('data-vp-user-changed', 'true');
        }
      });
    }

    if (select.getAttribute('data-vp-user-changed') === 'true' ||
        select.getAttribute('data-vp-default-applied') === 'true') return;

    var zeroMgIndex = -1;
    Array.prototype.some.call(select.options, function (option, index) {
      var label = normalise(option.textContent || option.value);
      if (/^0(?:\.0)?\s*mg\b/i.test(label)) {
        zeroMgIndex = index;
        return true;
      }
      return false;
    });

    if (zeroMgIndex < 0) return;
    select.setAttribute('data-vp-programmatic-change', 'true');
    select.selectedIndex = zeroMgIndex;
    select.setAttribute('data-vp-default-applied', 'true');
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.removeAttribute('data-vp-programmatic-change');
  }

  function initialiseNicotineSelects(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.vp-nicotine-choice')) initialiseNicotineSelect(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('.vp-nicotine-choice'), initialiseNicotineSelect);
  }

  function cardForForm(form) {
    return form.closest(
      '[data-product-card],.product-card,.yv-product-card,.yv-product-card-item,' +
      '.product-grid-item,.grid__item,.product-item,.product-card-item,li'
    ) || form.parentElement;
  }

  function productUrlForCard(form, card) {
    var link = card && card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
    if (link && link.href) return link.href;
    var handle = form.getAttribute('data-product-handle');
    return handle ? window.location.origin + '/products/' + encodeURIComponent(handle) : '';
  }

  function shouldRouteQuickAdd(form, card) {
    var handle = form.getAttribute('data-product-handle') || '';
    var title = form.getAttribute('data-product-title') || '';
    var cardText = card ? normalise(card.textContent) : '';
    var source = [handle.replace(/-/g, ' '), title, cardText].join(' ');
    var hasEligibleVolume = /(?:^|\D)(?:50|100|200)\s*ml\b/i.test(source);
    var isLiquid = /e[-\s]?liquid|short\s*fill|shortfill|vape\s*juice|bar\s*juice|e\s*juice/i.test(source);
    return hasEligibleVolume && isLiquid;
  }

  function handleQuickAdd(event) {
    var button = event.target && event.target.closest ? event.target.closest('.Sd_addProduct') : null;
    if (button) {
      var productForm = button.form || button.closest('form');
      var variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
      if (variantInput) {
        variantInput.disabled = false;
        if (!variantInput.value) {
          var variantJson = productForm.querySelector('[data-name="variant-json"]');
          if (variantJson) {
            try {
              var variants = JSON.parse(variantJson.textContent || '[]');
              if (variants.length === 1 && variants[0] && variants[0].id) {
                variantInput.value = String(variants[0].id);
              }
            } catch (error) {
              if (window.console && console.warn) console.warn('[VP] Variant fallback skipped.', error);
            }
          }
        }
      }
    }
    if (!button || event.defaultPrevented) return;
    var form = button.closest('form[data-product-handle]');
    if (!form) return;
    var card = cardForForm(form);
    if (!shouldRouteQuickAdd(form, card)) return;
    var productUrl = productUrlForCard(form, card);
    if (!productUrl) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    window.location.assign(productUrl);
  }

  function descriptionAlreadyPresent(descriptionText) {
    if (document.querySelector('.vp-full-description')) return true;
    var selectors = [
      '[data-product-description]',
      '.product__description',
      '.product-description',
      '.product-page-description',
      '.yv-product-description',
      '.yv-product-desc',
      '#product-description',
      'details[id*="description"]',
      '[data-tab-content="description"]'
    ];
    var known = document.querySelector(selectors.join(','));
    if (known && normalise(known.textContent).length > 30) return true;

    var main = document.querySelector('main');
    if (!main) return false;
    var sampleLength = Math.min(180, descriptionText.length);
    var sample = normalise(descriptionText.slice(0, sampleLength));
    return sample.length > 60 && normalise(main.textContent).indexOf(sample) !== -1;
  }

  function safeDescriptionFragment(html) {
    var parsed = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    var wrapper = parsed.body.firstElementChild;
    if (!wrapper) return null;
    Array.prototype.forEach.call(
      wrapper.querySelectorAll('script,style,iframe,object,embed,form,input,button'),
      function (node) { node.remove(); }
    );
    return wrapper;
  }

  function insertProductDescription(html, descriptionText) {
    if (descriptionAlreadyPresent(descriptionText)) return;
    var wrapper = safeDescriptionFragment(html);
    if (!wrapper || normalise(wrapper.textContent).length < 20) return;

    var section = document.createElement('section');
    var heading = document.createElement('h2');
    var headingId = uniqueId('vp-product-description-title');
    section.className = 'vp-full-description rte';
    section.setAttribute('data-vp-injected-description', 'true');
    section.setAttribute('aria-labelledby', headingId);
    heading.id = headingId;
    heading.textContent = 'Product description';
    section.appendChild(heading);
    while (wrapper.firstChild) section.appendChild(wrapper.firstChild);

    var productForm = document.querySelector('main form[action*="/cart/add"]');
    var anchor = productForm ? productForm.closest(
      '[data-product-section],.product-page,.product-detail,.yv-product-detail,.shopify-section'
    ) : null;
    if (!anchor) {
      anchor = document.querySelector(
        'main [data-product-section],main .product-page,main .product-detail,' +
        'main .yv-product-detail,main .shopify-section'
      );
    }
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(section, anchor.nextSibling);
    } else {
      var main = document.querySelector('main');
      if (main) main.appendChild(section);
    }
  }

  function loadMissingProductDescription() {
    if (!/^\/products\/[^/]+\/?$/.test(window.location.pathname)) return;
    if (document.documentElement.getAttribute('data-vp-description-requested') === 'true') return;
    document.documentElement.setAttribute('data-vp-description-requested', 'true');

    var endpoint = pathWithoutTrailingSlash() + '.js';
    fetch(endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Product description request failed: ' + response.status);
      return response.json();
    }).then(function (product) {
      var html = product && typeof product.description === 'string' ? product.description : '';
      var temp = safeDescriptionFragment(html);
      var text = temp ? normalise(temp.textContent) : '';
      if (html && text) insertProductDescription(html, text);
    }).catch(function (error) {
      if (window.console && console.warn) console.warn('[VP] Description enhancement skipped.', error);
    });
  }

  function removeStaleCartColumns() {
    if (pathWithoutTrailingSlash() !== '/cart') return;
    Array.prototype.forEach.call(document.querySelectorAll('.text-with-icon-column'), function (column) {
      var text = normalise(column.textContent).toLowerCase();
      var isClickAndCollect = text.indexOf('click and collect') !== -1;
      var isUnrelatedDeliverySocial = text.indexOf('free delivery') !== -1 && (
        text.indexOf('instagram') !== -1 ||
        text.indexOf('keep up with') !== -1 ||
        text.indexOf('follow us') !== -1 ||
        text.indexOf('social media') !== -1
      );
      if (isClickAndCollect || isUnrelatedDeliverySocial) column.remove();
    });
  }

  function addCartAssurance() {
    if (pathWithoutTrailingSlash() !== '/cart') return;
    var checkout = document.querySelector(
      '[name="checkout"],.cart__checkout-button,.checkout-button,.cart-checkout-btn,' +
      'a[href^="/checkout"]'
    );
    if (!checkout || !checkout.parentNode) return;

    var note = document.querySelector('.vp-checkout-assurance');
    if (!note) {
      note = document.createElement('aside');
      note.className = 'vp-checkout-assurance';
      note.setAttribute('role', 'note');
    }
    if (note.getAttribute('data-vp-content-version') !== '1') {
      note.innerHTML = [
        '<p><strong>Delivery:</strong> Free Royal Mail Tracked 48 on orders of £30 or more after discounts.</p>',
        '<p><strong>Secure payment:</strong> Debit/credit card, Pay by Bank and PayPal are available at checkout.</p>'
      ].join('');
      note.setAttribute('data-vp-content-version', '1');
    }
    if (!note.parentNode || note.nextElementSibling !== checkout) {
      checkout.parentNode.insertBefore(note, checkout);
    }
  }

  function ensureOfferCollectionHeading() {
    if (pathWithoutTrailingSlash() !== OFFER_COLLECTION_PATH) return null;
    var main = document.querySelector('main') || document.body;
    var headingCandidates = main.querySelectorAll('h1,h2,h3');
    var offerHeading = null;
    Array.prototype.some.call(headingCandidates, function (heading) {
      if (/10\s*(?:for|x)\s*£?\s*15/i.test(normalise(heading.textContent))) {
        offerHeading = heading;
        return true;
      }
      return false;
    });

    var h1s = main.querySelectorAll('h1');
    if (offerHeading && offerHeading.tagName !== 'H1') offerHeading = replaceTag(offerHeading, 'h1');
    if (!offerHeading && h1s.length) offerHeading = h1s[0];
    if (!offerHeading) return null;

    Array.prototype.forEach.call(main.querySelectorAll('h1'), function (heading) {
      if (heading !== offerHeading) replaceTag(heading, 'h2');
    });
    return offerHeading;
  }

  function isExistingSingleVariantQuickAdd(button) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    var form = button.closest('form[data-product-handle]');
    // This theme only renders this quick-add form for products with one
    // purchasable variant. Multi-variant cards contain no such form and still
    // route shoppers to the product page to choose a nicotine strength.
    return !!form;
  }

  function exposeOfferCollectionQuickAdds() {
    if (pathWithoutTrailingSlash() !== OFFER_COLLECTION_PATH || !document.body) return;
    document.body.classList.add('vp-offer-collection');
    Array.prototype.forEach.call(document.querySelectorAll('.Sd_addProduct'), function (button) {
      if (!isExistingSingleVariantQuickAdd(button)) return;
      button.classList.add('vp-single-variant-quick-add');
      button.setAttribute('data-vp-single-variant-quick-add', 'true');
      button.setAttribute('tabindex', '0');
    });
  }

  function addOfferCollectionTerms() {
    if (pathWithoutTrailingSlash() !== OFFER_COLLECTION_PATH) return;
    exposeOfferCollectionQuickAdds();
    var heading = ensureOfferCollectionHeading();
    var terms = document.querySelector('.vp-offer-terms');
    if (!terms) {
      terms = document.createElement('aside');
      terms.className = 'vp-offer-terms';
      terms.setAttribute('role', 'note');
      terms.setAttribute('data-vp-offer-terms', 'true');
    }
    if (terms.getAttribute('data-vp-content-version') !== '2') {
      terms.innerHTML = '<p><strong>10 for £15:</strong> Choose 10 qualifying £2 10ml e-liquids, or 10 qualifying ' +
        'ELUX Fire Rose 5000 nic salts at £1.79 each. These are separate ten-bottle offers; ' +
        'do not mix the two groups to reach ten. Discounts apply automatically to eligible items ' +
        'and your basket shows the savings before checkout. Other promotions may not combine.</p>';
      terms.setAttribute('data-vp-content-version', '2');
    }

    var grid = document.querySelector(
      '#product-grid,[id^="product-grid"],[data-product-grid],.yv-products-container,' +
      '.collection-products,.collection-product-grid,.product-grid'
    );
    if (grid && grid.parentNode) {
      if (terms.parentNode !== grid.parentNode || terms.nextElementSibling !== grid) {
        grid.parentNode.insertBefore(terms, grid);
      }
    } else if (heading && heading.parentNode) {
      heading.parentNode.insertBefore(terms, heading.nextSibling);
    }
  }

  function isContactPage() {
    return /^\/(?:pages\/)?contact(?:-us)?\/?$/i.test(window.location.pathname);
  }

  function removeObsoleteContactAddress(root) {
    var addressPattern = /38\s+Elizabeth\s+(?:St(?:reet)?\.?)[\s,]*(?:Corby[\s,]*)?(?:Northamptonshire[\s,]*)?(?:NN17\s*1PN)?/i;
    var addressReplace = /38\s+Elizabeth\s+(?:St(?:reet)?\.?)[\s,]*(?:Corby[\s,]*)?(?:Northamptonshire[\s,]*)?(?:NN17\s*1PN)?/gi;
    var candidates = root.querySelectorAll('address,p,li,span');
    Array.prototype.forEach.call(candidates, function (element) {
      var text = normalise(element.textContent);
      if (!addressPattern.test(text)) return;
      var hasContactDetail = !!element.querySelector('a[href^="tel:"],a[href^="mailto:"]') ||
        /support@vapersplace\.co\.uk|01536\s*269622/i.test(text);
      if (!hasContactDetail && text.length < 260) {
        element.remove();
      }
    });

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      if (addressPattern.test(node.nodeValue || '')) {
        node.nodeValue = (node.nodeValue || '').replace(addressReplace, '').replace(/^[\s,|–—-]+|[\s,|–—-]+$/g, ' ');
      }
    });
  }

  function removeContactMaps(root) {
    var selectors = [
      'iframe[src*="google.com/maps"]',
      'iframe[src*="maps.google"]',
      '[data-map-container]',
      '[data-store-locator]',
      '#store-locator',
      '.store-locator',
      '[id*="store-locator"]',
      '[class*="store-locator"]'
    ];
    Array.prototype.forEach.call(root.querySelectorAll(selectors.join(',')), function (node) {
      if (node.matches('iframe')) {
        node.remove();
        return;
      }
      var nodeText = normalise(node.textContent);
      var hasContactDetail = !!node.querySelector('a[href^="tel:"],a[href^="mailto:"]') ||
        /support@vapersplace\.co\.uk|01536\s*269622/i.test(nodeText);
      if (!hasContactDetail) node.remove();
    });
  }

  function linkContactDetails(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach(function (node) {
      var parent = node.parentElement;
      if (!parent || parent.closest('a,script,style,noscript,textarea,input,select')) return;
      var value = node.nodeValue || '';
      var pattern = /(support@vapersplace\.co\.uk|01536\s*269622)/ig;
      if (!pattern.test(value)) return;
      pattern.lastIndex = 0;

      var fragment = document.createDocumentFragment();
      var lastIndex = 0;
      var match;
      while ((match = pattern.exec(value))) {
        if (match.index > lastIndex) fragment.appendChild(document.createTextNode(value.slice(lastIndex, match.index)));
        var link = document.createElement('a');
        var matchedText = match[0];
        if (matchedText.toLowerCase().indexOf('@') !== -1) {
          link.href = 'mailto:' + SUPPORT_EMAIL;
          link.textContent = SUPPORT_EMAIL;
        } else {
          link.href = 'tel:+441536269622';
          link.textContent = SUPPORT_PHONE;
        }
        fragment.appendChild(link);
        lastIndex = pattern.lastIndex;
      }
      if (lastIndex < value.length) fragment.appendChild(document.createTextNode(value.slice(lastIndex)));
      if (node.parentNode) node.parentNode.replaceChild(fragment, node);
    });
  }

  function cleanContactPage() {
    if (!isContactPage()) return;
    var root = document.querySelector('main') || document.body;
    if (!root) return;
    removeObsoleteContactAddress(root);
    removeContactMaps(root);
    linkContactDetails(root);
  }

  function ageModalCandidate() {
    var selectors = [
      '[data-age-verification]',
      '[data-age-gate]',
      '#age-verification-popup',
      '.age-verification-popup',
      '#age-verification',
      '.age-verification',
      '#age-gate',
      '.age-gate'
    ];
    var candidates = document.querySelectorAll(selectors.join(','));
    var visibleCandidate = null;
    var fallback = null;
    Array.prototype.forEach.call(candidates, function (candidate) {
      var text = normalise(candidate.textContent);
      if (!/(?:18|legal age|age verification|years old)/i.test(text)) return;
      if (!fallback) fallback = candidate;
      if (!visibleCandidate && isVisible(candidate)) visibleCandidate = candidate;
    });
    return visibleCandidate || fallback;
  }

  function focusableElements(container) {
    var selector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
      'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(selector), function (element) {
      return isVisible(element);
    });
  }

  function enhanceAgeModal() {
    var modal = ageModalCandidate();
    if (!modal) return;
    var modalOpen = isRendered(modal) && (
      modal.classList.contains('active') ||
      modal.getAttribute('data-open') === 'true' ||
      modal.getAttribute('open') !== null
    );
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', modalOpen ? 'false' : 'true');
    if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');

    var panels = modal.querySelectorAll('.age-verification-outer,.age-verification-decline');
    var activePanel = null;
    Array.prototype.some.call(panels, function (panel) {
      if (isRendered(panel) && !panel.classList.contains('inactive')) {
        activePanel = panel;
        return true;
      }
      return false;
    });
    var labelScope = activePanel || modal;
    var heading = labelScope.querySelector('h1,h2,h3,h4,[data-age-title]');
    if (heading) {
      if (!heading.id) heading.id = uniqueId('vp-age-title');
      modal.setAttribute('aria-labelledby', heading.id);
      modal.removeAttribute('aria-label');
    } else if (!modal.hasAttribute('aria-label')) {
      modal.setAttribute('aria-label', 'Age verification');
    }

    var description = labelScope.querySelector('p,[data-age-description]');
    if (description) {
      if (!description.id) description.id = uniqueId('vp-age-description');
      modal.setAttribute('aria-describedby', description.id);
    }

    if (modal.getAttribute('data-vp-focus-trap') !== 'true') {
      modal.setAttribute('data-vp-focus-trap', 'true');
      modal.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || modal.getAttribute('aria-hidden') === 'true') return;
        var focusable = focusableElements(modal);
        if (!focusable.length) {
          event.preventDefault();
          modal.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    if (modalOpen && modal.getAttribute('data-vp-initial-focus') !== 'true') {
      modal.setAttribute('data-vp-initial-focus', 'true');
      modal.__vpPreviousFocus = document.activeElement;
      var buttons = modal.querySelectorAll('button,a,[role="button"]');
      var confirmButton = null;
      Array.prototype.some.call(buttons, function (button) {
        var label = normalise(button.textContent || button.getAttribute('aria-label'));
        if (/^(?:yes|enter|continue|confirm)|over\s*18|i\s*am\s*18/i.test(label)) {
          confirmButton = button;
          return true;
        }
        return false;
      });
      (confirmButton || focusableElements(modal)[0] || modal).focus();
    } else if (!modalOpen && modal.getAttribute('data-vp-initial-focus') === 'true') {
      modal.removeAttribute('data-vp-initial-focus');
      if (modal.__vpPreviousFocus && typeof modal.__vpPreviousFocus.focus === 'function') {
        modal.__vpPreviousFocus.focus();
      }
      modal.__vpPreviousFocus = null;
    }
  }

  function shopifyRoute(endpoint) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + endpoint.replace(/^\//, '');
  }

  function nicotineOptionValue(properties) {
    if (!properties || typeof properties !== 'object') return '';
    var keys = Object.keys(properties);
    for (var index = 0; index < keys.length; index += 1) {
      if (normalise(keys[index]).toLowerCase() === 'nicotine option') {
        return normalise(properties[keys[index]]);
      }
    }
    return '';
  }

  function paidZeusShotCount(item) {
    var option = nicotineOptionValue(item && item.properties);
    if (!option || !/zeus/i.test(option) || !/(?:nic\s*salt|salt\s*shot)/i.test(option)) return 0;

    var match = option.match(/(?:add(?:ing)?\s*)?(\d+)\s*(?:x|×)\s*zeus/i) ||
      option.match(/add(?:ing)?\s*(\d+)\s*(?:x|×)?/i) ||
      option.match(/(\d+)\s*(?:x|×)\s*(?:zeus|20\s*mg)/i);
    var count = match ? parseInt(match[1], 10) : 0;
    if (!count) {
      var priceMatch = option.match(/\+\s*£\s*(\d+(?:\.\d+)?)/i);
      if (priceMatch) count = Math.round(parseFloat(priceMatch[1]));
    }
    if (!count && /zeus/i.test(option)) count = 1;
    return count > 0 && count <= 20 ? count : 0;
  }

  function propertyValue(properties, key) {
    if (!properties || typeof properties !== 'object') return '';
    return properties[key] == null ? '' : normalise(properties[key]);
  }

  function desiredZeusShotGroups(cart) {
    return (cart.items || []).reduce(function (groups, item) {
      if (Number(item.variant_id || item.id) === ZEUS_SHOT_VARIANT_ID) return groups;
      var group = propertyValue(item.properties, '_vp_addon_group');
      if (!group) return groups;
      var perItem = parseInt(propertyValue(item.properties, '_vp_shots_per_bottle'), 10) ||
        paidZeusShotCount(item);
      if (!perItem || perItem < 1 || perItem > 20) return groups;
      groups[group] = {
        quantity: (groups[group] ? groups[group].quantity : 0) +
          (perItem * Number(item.quantity || 0)),
        productTitle: normalise(item.product_title || item.title || 'Shortfill')
      };
      return groups;
    }, {});
  }

  function cartUiExists() {
    return pathWithoutTrailingSlash() === '/cart' || !!document.querySelector(
      '[data-cart-drawer],#CartDrawer,.cart-drawer,.mini-cart,[data-mini-cart],form[action="/cart"]'
    );
  }

  function notifyCartUpdated(cart) {
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { cart: cart } }));
    });
  }

  function fetchCart() {
    return fetch(shopifyRoute('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return response.json();
    });
  }

  function managedShotGroup(item) {
    if (Number(item.variant_id || item.id) !== ZEUS_SHOT_VARIANT_ID) return '';
    return propertyValue(item.properties, '_vp_addon_group');
  }

  function updateShotLines(shotItems, desiredGroups) {
    var updates = {};
    var changed = false;
    var seenGroups = {};
    shotItems.forEach(function (item) {
      var group = managedShotGroup(item);
      var desired = desiredGroups[group] ? desiredGroups[group].quantity : 0;
      var nextQuantity = seenGroups[group] ? 0 : desired;
      seenGroups[group] = true;
      if (Number(item.quantity) !== nextQuantity) changed = true;
      updates[item.key] = nextQuantity;
    });
    if (!changed) return Promise.resolve(null);

    return fetch(shopifyRoute('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart shot update failed: ' + response.status);
      return response.json();
    });
  }

  function addShotLines(items) {
    if (!items.length) return Promise.resolve(null);
    return fetch(shopifyRoute('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart shot add failed: ' + response.status);
      return response.json();
    }).then(function () {
      return fetchCart();
    });
  }

  function synchroniseZeusShots() {
    if (!cartUiExists()) return Promise.resolve();
    if (shotSyncRunning) {
      shotSyncPending = true;
      return Promise.resolve();
    }
    shotSyncRunning = true;

    return fetchCart().then(function (cart) {
      var desiredGroups = desiredZeusShotGroups(cart);
      var shotItems = (cart.items || []).filter(function (item) {
        return !!managedShotGroup(item);
      });
      var presentGroups = shotItems.reduce(function (groups, item) {
        groups[managedShotGroup(item)] = true;
        return groups;
      }, {});
      var missingItems = Object.keys(desiredGroups).filter(function (group) {
        return !presentGroups[group] && desiredGroups[group].quantity > 0;
      }).map(function (group) {
        return {
          id: ZEUS_SHOT_VARIANT_ID,
          quantity: desiredGroups[group].quantity,
          properties: {
            _vp_addon_group: group,
            _vp_added_with: desiredGroups[group].productTitle,
            _vp_auto_added: 'Nicotine option'
          }
        };
      });
      return updateShotLines(shotItems, desiredGroups).then(function (updatedCart) {
        return addShotLines(missingItems).then(function (addedCart) {
          return addedCart || updatedCart;
        });
      });
    }).then(function (updatedCart) {
      if (!updatedCart) return;
      notifyCartUpdated(updatedCart);
      if (pathWithoutTrailingSlash() === '/cart') {
        window.setTimeout(function () { window.location.reload(); }, 120);
      }
    }).catch(function (error) {
      if (window.console && console.warn) console.warn('[VP] Zeus shot synchronisation skipped.', error);
    }).then(function () {
      shotSyncRunning = false;
      if (shotSyncPending) {
        shotSyncPending = false;
        scheduleShotSync(900);
      }
    });
  }

  function scheduleShotSync(delay) {
    if (!cartUiExists()) return;
    window.clearTimeout(shotSyncTimer);
    shotSyncTimer = window.setTimeout(synchroniseZeusShots, typeof delay === 'number' ? delay : 900);
  }

  function isCartQuantityInput(target) {
    return !!(target && target.matches && target.matches(
      'input[name="updates[]"],input[name^="updates"],[data-quantity-input],.quantity input[type="number"]'
    ));
  }

  function isCartQuantityOrRemoveControl(target) {
    if (!target || !target.closest) return false;
    var cart = target.closest(
      'form[action="/cart"],[data-cart-drawer],#CartDrawer,.cart-drawer,.mini-cart,[data-mini-cart],[data-cart-items]'
    );
    if (!cart) return false;
    var control = target.closest(
      '[data-cart-remove],[data-quantity-minus],[data-quantity-plus],.quantity__button,.quantity-button,' +
      'a[href*="/cart/change"],button[aria-label*="remove" i],button[aria-label*="quantity" i]'
    );
    return !!control;
  }

  function enhancePage() {
    installStyles();
    initialiseNicotineSelects(document);
    removeStaleCartColumns();
    addCartAssurance();
    addOfferCollectionTerms();
    cleanContactPage();
    enhanceAgeModal();
    loadMissingProductDescription();
  }

  function scheduleEnhance() {
    window.clearTimeout(enhanceTimer);
    enhanceTimer = window.setTimeout(enhancePage, 80);
  }

  function observePage() {
    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (records) {
      scheduleEnhance();
      var cartChanged = records.some(function (record) {
        var target = record.target && record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return !!(target && target.closest && target.closest(
          'form[action="/cart"],[data-cart-drawer],#CartDrawer,.cart-drawer,.mini-cart,[data-mini-cart],[data-cart-items]'
        ));
      });
      if (cartChanged && !shotSyncRunning) scheduleShotSync(1100);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  function start() {
    enhancePage();
    observePage();
    scheduleShotSync(1200);

    document.addEventListener('click', handleQuickAdd, true);
    document.addEventListener('change', function (event) {
      if (isCartQuantityInput(event.target)) scheduleShotSync(1000);
    }, true);
    document.addEventListener('click', function (event) {
      if (isCartQuantityOrRemoveControl(event.target)) scheduleShotSync(1100);
    }, true);
    window.addEventListener('pageshow', function () {
      scheduleEnhance();
      scheduleShotSync(900);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
/* Make the shared £1.49 / 10-for-£12 range easy to find. */
(function () {
  var COLLECTION_PATH = '/collections/1-49-nic-salts-mix-any-10-for-12';
  var timer = 0;

  function cleanPath() {
    return window.location.pathname.replace(/\/$/, '') || '/';
  }

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function installStyles() {
    if (document.getElementById('vp-elfliq-merchandising-styles')) return;
    var style = document.createElement('style');
    style.id = 'vp-elfliq-merchandising-styles';
    style.textContent = [
      '.vp-elfliq-offer{box-sizing:border-box;width:100%;max-width:100%;margin:0 0 1.5rem;padding:1rem 1.15rem;border:2px solid #111;border-radius:8px;background:#fff7d6;text-align:center;}',
      '.vp-elfliq-offer h2{margin:0 0 .4rem;font-size:clamp(1.25rem,2.4vw,2rem);}',
      '.vp-elfliq-offer p{margin:.25rem 0;}',
      '.vp-elfliq-offer a{font-weight:700;text-decoration:underline;}',
      '.vp-elfliq-range-link{box-sizing:border-box;margin:1.25rem auto;padding:1rem;max-width:1200px;border:1px solid rgba(0,0,0,.14);border-radius:8px;background:#fff7d6;text-align:center;}',
      '.vp-elfliq-range-link p{margin:.25rem 0;}',
      '.vp-elfliq-range-link a{font-weight:700;text-decoration:underline;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function offerColumn(text) {
    var columns = document.querySelectorAll('[id^="collageItem-"]');
    for (var index = 0; index < columns.length; index += 1) {
      if (normalise(columns[index].textContent).indexOf(text) !== -1) return columns[index];
    }
    return null;
  }

  function updateHomepage() {
    if (cleanPath() !== '/') return;
    var fifteen = offerColumn('10 for £15');
    var eight = offerColumn('10 for £8');
    if (!fifteen || !eight || !eight.parentNode) return;

    [fifteen, eight].forEach(function (column) {
      column.className = column.className.replace(/col-md-6\b/g, 'col-md-4');
    });

    var sharedDeal = document.querySelector('[data-vp-mix-10-for-12-home-card="true"]');
    if (!sharedDeal) {
      sharedDeal = eight.cloneNode(true);
      sharedDeal.removeAttribute('id');
      sharedDeal.setAttribute('data-vp-mix-10-for-12-home-card', 'true');
      eight.parentNode.insertBefore(sharedDeal, eight.nextSibling);
    }
    sharedDeal.className = sharedDeal.className.replace(/col-md-6\b/g, 'col-md-4');
    Array.prototype.forEach.call(sharedDeal.querySelectorAll('h3'), function (heading) {
      heading.textContent = '🔥 £1.49 E-LIQUIDS 10 for £12 🔥';
    });
    var paragraph = sharedDeal.querySelector('p');
    if (paragraph) paragraph.textContent = '£1.49 each • Mix any 10 bottles';
    Array.prototype.forEach.call(sharedDeal.querySelectorAll('a'), function (link) {
      link.setAttribute('href', COLLECTION_PATH);
      link.textContent = 'Shop 10 for £12';
      link.setAttribute('aria-label', 'Shop qualifying £1.49 e-liquids - mix any 10 for £12');
    });
  }

  function promoteNavigation() {
    Array.prototype.forEach.call(
      document.querySelectorAll('a[href="/collections/elfliq"],a[href$="/collections/elfliq"]'),
      function (link) {
        var label = link.querySelector('span');
        if (label) label.textContent = 'ELFLIQ – £1.49 each / 10 for £12';
        else if (!link.querySelector('img,.image-wrapper')) link.textContent = 'ELFLIQ – £1.49 each / 10 for £12';
        var item = link.closest('li');
        if (item && item.parentNode && item.parentNode.firstElementChild !== item) {
          item.parentNode.insertBefore(item, item.parentNode.firstElementChild);
        }
      }
    );
  }

  function addCollectionOffer() {
    if (cleanPath() !== COLLECTION_PATH) return;
    var products = document.querySelector('.collection-products-section .yv-collection-container > .yv-collection-products');
    var host = products && products.parentNode;
    if (!host) return;
    var offer = document.querySelector('.vp-elfliq-offer');
    if (!offer) {
      offer = document.createElement('aside');
      offer.className = 'vp-elfliq-offer';
      offer.setAttribute('role', 'note');
      offer.innerHTML = [
        '<h2>🔥 £1.49 E-LIQUIDS — MIX ANY 10 FOR £12 🔥</h2>',
        '<p><strong>Mix any 10 qualifying ELFLIQ, ELUX, Bar Juice 5000 and selected nic-salt bottles for £12.</strong></p>',
        '<p>The £2.90 saving is applied automatically in your cart when you add 10 bottles.</p>'
      ].join('');
    }
    if (offer.parentNode !== host || offer.nextElementSibling !== products) {
      host.insertBefore(offer, products);
    }
  }

  function prioritiseCollectionProducts() {
    if (cleanPath() !== COLLECTION_PATH || window.location.search.indexOf('sort_by=') !== -1) return;
    var row = document.querySelector('[data-collection-products]');
    if (!row) return;
    var priorities = [
      '/products/elfliq-watermelon-nic-salt-e-liquid-10ml',
      '/products/elfliq-blueberry-sour-raspberry-nic-salt-e-liquid-10ml',
      '/products/elfliq-blue-razz-lemonade-nic-salt-e-liquid-10ml',
      '/products/elfliq-kiwi-passion-fruit-guava-nic-salt-e-liquid-10ml'
    ];
    priorities.slice().reverse().forEach(function (path) {
      var link = row.querySelector('a[href="' + path + '"]');
      var card = link && link.closest('[data-product-grid]');
      if (card) row.insertBefore(card, row.firstElementChild);
    });
  }

  function isElfliqProduct() {
    if (!/^\/products\//.test(cleanPath())) return false;
    var heading = document.querySelector('main h1');
    return !!(heading && /^ELFLIQ\b/i.test(normalise(heading.textContent)));
  }

  function replaceCompetingRecommendations() {
    if (!isElfliqProduct()) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('section.product-page-recommendations,[product-recommendations],.product-recommendations'),
      function (node) {
        var section = node.closest('section') || node;
        section.style.setProperty('display', 'none', 'important');
        section.setAttribute('aria-hidden', 'true');
      }
    );
    if (document.querySelector('.vp-elfliq-range-link')) return;
    var main = document.querySelector('main');
    if (!main) return;
    var callout = document.createElement('aside');
    callout.className = 'vp-elfliq-range-link';
    callout.innerHTML = [
      '<p><strong>Mix your £1.49 bundle</strong></p>',
      '<p><a href="' + COLLECTION_PATH + '">Shop all qualifying £1.49 e-liquids — mix any 10 for £12</a></p>'
    ].join('');
    main.appendChild(callout);
  }

  function enhance() {
    installStyles();
    updateHomepage();
    addCollectionOffer();
    prioritiseCollectionProducts();
    replaceCompetingRecommendations();
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(enhance, 90);
  }

  function start() {
    enhance();
    if (document.body && window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(function () {
  'use strict';

  var MARKER_ID = 'vp-contact-prominence';

  function installStyles() {
    if (document.getElementById(MARKER_ID + '-styles')) return;

    var style = document.createElement('style');
    style.id = MARKER_ID + '-styles';
    style.textContent = [
      '.vp-contact-card{margin:18px 0 32px;padding:clamp(22px,4vw,38px);border-radius:18px;background:linear-gradient(135deg,#111827 0%,#253248 100%);color:#fff;box-shadow:0 14px 34px rgba(17,24,39,.18)}',
      '.vp-contact-card__eyebrow{margin:0 0 8px;font-size:13px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#ffd54a}',
      '.vp-contact-card h2{margin:0 0 10px;color:#fff;font-size:clamp(26px,4vw,40px);line-height:1.12}',
      '.vp-contact-card__intro{max-width:700px;margin:0 0 22px;color:#f3f4f6;font-size:clamp(16px,2vw,19px);line-height:1.55}',
      '.vp-contact-card__actions{display:flex;flex-wrap:wrap;gap:12px}',
      '.vp-contact-card__action{display:inline-flex;align-items:center;justify-content:center;min-height:52px;padding:13px 20px;border:2px solid #ffd54a;border-radius:10px;background:#ffd54a;color:#111827!important;font-size:17px;font-weight:800;line-height:1.2;text-decoration:none!important;transition:transform .15s ease,box-shadow .15s ease}',
      '.vp-contact-card__action:hover,.vp-contact-card__action:focus{transform:translateY(-1px);box-shadow:0 8px 18px rgba(0,0,0,.22)}',
      '.vp-contact-card__action--email{background:transparent;color:#fff!important}',
      '.vp-contact-card__note{margin:17px 0 0;color:#dbe3ee;font-size:14px}',
      '@media(max-width:560px){.vp-contact-card__actions{display:grid}.vp-contact-card__action{width:100%}.vp-contact-card{border-radius:14px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function enhanceContactPage() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/contact') return;
    if (document.getElementById(MARKER_ID)) return;

    var main = document.querySelector('main, #MainContent');
    if (!main) return;

    var title = Array.prototype.find.call(main.querySelectorAll('h1'), function (heading) {
      return heading.textContent.trim().toLowerCase() === 'contact';
    });
    if (!title) return;

    var phone = main.querySelector('a[href^="tel:"]');
    var email = main.querySelector('a[href^="mailto:"]');
    if (!phone || !email) return;

    var card = document.createElement('section');
    card.id = MARKER_ID;
    card.className = 'vp-contact-card';
    card.setAttribute('aria-labelledby', MARKER_ID + '-heading');

    var eyebrow = document.createElement('p');
    eyebrow.className = 'vp-contact-card__eyebrow';
    eyebrow.textContent = 'Contact Vapers Place';

    var heading = document.createElement('h2');
    heading.id = MARKER_ID + '-heading';
    heading.textContent = "We're here to help";

    var intro = document.createElement('p');
    intro.className = 'vp-contact-card__intro';
    intro.textContent = 'Questions about an order or need help choosing a product? Call or email us directly.';

    var actions = document.createElement('div');
    actions.className = 'vp-contact-card__actions';

    var callLink = document.createElement('a');
    callLink.className = 'vp-contact-card__action';
    callLink.href = phone.href;
    callLink.textContent = 'Call ' + phone.textContent.trim();

    var emailLink = document.createElement('a');
    emailLink.className = 'vp-contact-card__action vp-contact-card__action--email';
    emailLink.href = email.href;
    emailLink.textContent = 'Email ' + email.textContent.trim();

    var note = document.createElement('p');
    note.className = 'vp-contact-card__note';
    note.textContent = 'Tap either option to contact us now.';

    actions.appendChild(callLink);
    actions.appendChild(emailLink);
    card.appendChild(eyebrow);
    card.appendChild(heading);
    card.appendChild(intro);
    card.appendChild(actions);
    card.appendChild(note);

    title.insertAdjacentElement('afterend', card);

    var originalDetails = phone.closest('p');
    var originalHeading = originalDetails && originalDetails.previousElementSibling;
    if (originalDetails) originalDetails.hidden = true;
    if (originalHeading && originalHeading.tagName === 'P' && /contact vapers place/i.test(originalHeading.textContent)) {
      originalHeading.hidden = true;
    }
  }

  function run() {
    installStyles();
    enhanceContactPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
})();





(function () {
  'use strict';
  if (window.__vpK25AddonLoaded) return;
  window.__vpK25AddonLoaded = true;

  var K25_VARIANT_ID = 47221900673325;
  var ELIGIBLE_HANDLES = {
    'geek-vape-aegis-solo-2-s100-mod-vape-kit-rainbow': true,
    'voopoo-drag-x-pnp-x-kit-knight-gray': true,
    'geekvape-b100-aegis-boost-pro-pod-vape-kit-silver': true,
    'innokin-coolfire-z80-zenith-ii-pod-vape-kit-ash-grey': true,
    'geek-vape-s100-100w-mod-vape-kit-rainbow': true,
    'voopoo-drag-x2-2ml-tpd-vape-pod-kit': true,
    'geek-vape-b100-mod-vape-kit-rainbow': true,
    'geek-vape-e100-mod-vape-kit-beige': true,
    'voopoo-drag-x-pnp-x-kit-shield-gold': true,
    'geek-vape-e100-mod-vape-kit-rainbow': true,
    'geek-vape-aegis-s100-solo-2-mod-vape-kit-classic-black': true,
    'geek-vape-e100-mod-vape-kit-volcanic-grey': true,
    'voopoo-drag-h80s-pod-vape-kit-grey-carbon-fiber': true,
    'voopoo-drag-h80s-pod-vape-kit-golden': true,
    'voopoo-drag-h80s-pod-vape-kit-plum-red': true,
    'smok-g-priv-pro-pod-vape-kit-2ml-matte-blue': true
  };
  var DUAL_ELIGIBLE_HANDLES = {
    'geekvape-aegis-legend-iii-200w-vape-mod': true
  };

  function currentHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function isVisible(el) {
    if (!el) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' &&
      !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function visibleMainForm() {
    var forms = document.querySelectorAll('main form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i += 1) {
      var button = forms[i].querySelector('button[type="submit"], input[type="submit"]');
      if (button && isVisible(button)) return forms[i];
    }
    return null;
  }

  function quantityFor(form) {
    var input = form.querySelector('input[name="quantity"]');
    if (!input) {
      var candidates = document.querySelectorAll('main input[type="number"]');
      for (var i = 0; i < candidates.length; i += 1) {
        if (isVisible(candidates[i])) {
          input = candidates[i];
          break;
        }
      }
    }
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function installStyles() {
    if (document.getElementById('vp-k25-addon-styles')) return;
    var style = document.createElement('style');
    style.id = 'vp-k25-addon-styles';
    style.textContent = [
      '.vp-k25-addon{margin:14px 0 16px;padding:14px;border:2px solid #111827;border-radius:10px;background:#fff7d6;}',
      '.vp-k25-addon label{display:block;margin:0 0 7px;font-weight:800;color:#111827;}',
      '.vp-k25-addon select{display:block;width:100%;min-height:48px;padding:10px 38px 10px 12px;border:1px solid #111827;border-radius:7px;background:#fff;color:#111827;font-size:16px;}',
      '.vp-k25-addon p{margin:8px 0 0;font-size:13px;line-height:1.4;color:#374151;}',
      '.vp-k25-addon[aria-busy="true"]{opacity:.72;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function addBoth(form, select, box, event) {
    if (select.value !== 'k25' && select.value !== 'k25-pair') return;

    var idInput = form.querySelector('[name="id"]');
    var kitId = idInput ? parseInt(idInput.value, 10) : 0;
    if (!kitId || form.getAttribute('data-vp-k25-busy') === 'true') {
      if (!kitId) return;
      event.preventDefault();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    form.setAttribute('data-vp-k25-busy', 'true');
    box.setAttribute('aria-busy', 'true');

    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    var oldText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (button.tagName === 'BUTTON') button.textContent = 'Adding kit and battery...';
    }

    var qty = quantityFor(form);
    var batteryQty = select.value === 'k25-pair' ? qty * 2 : qty;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ?
      window.Shopify.routes.root : '/';

    fetch(root.replace(/\/?$/, '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: kitId, quantity: qty },
          {
            id: K25_VARIANT_ID,
            quantity: batteryQty,
            properties: {
              '_Added with': (document.querySelector('main h1') || {}).textContent || '18650 device'
            }
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data && (data.description || data.message) || 'Could not add both items.');
        });
      }
      return response.json();
    }).then(function () {
      window.location.assign(root.replace(/\/?$/, '/') + 'cart');
    }).catch(function (error) {
      form.removeAttribute('data-vp-k25-busy');
      box.removeAttribute('aria-busy');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (button.tagName === 'BUTTON') button.textContent = oldText || 'Add to cart';
      }
      window.alert(error.message || 'The kit or battery could not be added. Please try again.');
    });
  }

  function setAcceleratedCheckoutVisibility(form, hidden) {
    var scope = form.closest('[data-product-section], .product-page, .product-detail, .yv-product-detail, .shopify-section') || form.parentElement;
    if (!scope) return;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-shopify="payment-button"], .shopify-payment-button'),
      function (element) {
        element.hidden = hidden;
        element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }
    );
  }

  function enhance() {
    var handle = currentHandle();
    var isDual = !!DUAL_ELIGIBLE_HANDLES[handle];
    if (!ELIGIBLE_HANDLES[handle] && !isDual) return;
    installStyles();

    var form = visibleMainForm();
    if (!form || form.getAttribute('data-vp-k25-addon') === 'true') return;

    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!button) return;

    var box = document.createElement('div');
    box.className = 'vp-k25-addon';
    box.setAttribute('data-vp-k25-addon', 'true');

    var label = document.createElement('label');
    label.setAttribute('for', 'vp-k25-choice');
    label.textContent = 'Battery option';

    var select = document.createElement('select');
    select.id = 'vp-k25-choice';
    select.name = 'vp_k25_choice';

    var none = document.createElement('option');
    none.value = 'none';
    none.textContent = 'No battery';

    var add = document.createElement('option');
    add.value = isDual ? 'k25-pair' : 'k25';
    add.textContent = isDual ?
      'Add 2 Vapcell K25 2500mAh - 20A continuous / 35A max (+£8)' :
      'Add Vapcell K25 2500mAh - 20A continuous / 35A max (+£4)';

    select.appendChild(none);
    select.appendChild(add);

    var note = document.createElement('p');
    note.textContent = isDual ?
      'Two matched removable 18650 batteries are required. The £8 pair is added as two separate battery units.' :
      'One removable 18650 battery is required. The £4 battery is added as a separate basket item.';

    box.appendChild(label);
    box.appendChild(select);
    box.appendChild(note);
    button.parentNode.insertBefore(box, button);

    select.addEventListener('change', function () {
      setAcceleratedCheckoutVisibility(form, select.value !== 'none');
    });
    setAcceleratedCheckoutVisibility(form, false);

    form.setAttribute('data-vp-k25-addon', 'true');
    form.addEventListener('submit', function (event) {
      addBoth(form, select, box, event);
    }, true);
        button.addEventListener('click', function (event) {
      addBoth(form, select, box, event);
    }, true);
  }

  var timer = 0;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(enhance, 80);
  }

  function start() {
    enhance();
    if (document.body && window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* Keep the longer £1.49 homepage offer heading and CTA inside its card. */
(function () {
  var id = 'vp-shared-home-card-layout-fix';
  if (document.getElementById(id)) return;
  var style = document.createElement('style');
  style.id = id;
  style.textContent = [
    '[data-vp-mix-10-for-12-home-card="true"] h3{font-size:clamp(1.5rem,2vw,2.4rem)!important;line-height:1.08!important;margin-bottom:.25rem!important;}',
    '[data-vp-mix-10-for-12-home-card="true"] p{margin:.1rem 0 .35rem!important;}'
  ].join('');
  (document.head || document.documentElement).appendChild(style);
})();
/* Make the three homepage multi-buy offers prominent and equally weighted. */
(function () {
  var STYLE_ID = 'vp-home-offers-prominence-v2';
  var OLD_STYLE_ID = 'vp-shared-home-card-layout-fix';

  function markOfferCards() {
    if (window.location.pathname.replace(/\/$/, '') !== '') return;

    var cards = [];
    Array.prototype.forEach.call(document.querySelectorAll('h3'), function (heading) {
      var label = String(heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/10\s+for\s+£(?:15|8|12)\b/i.test(label)) return;

      var column = heading.closest('.col-12.col-md-4');
      if (!column || cards.indexOf(column) !== -1) return;
      column.classList.add('vp-home-offer-card');
      column.setAttribute('data-vp-home-offer', String(cards.length + 1));
      Array.prototype.forEach.call(column.querySelectorAll('a.button'), function (button) {
        button.setAttribute('aria-label', cards.length === 0
          ? 'Shop 10 for £15 e-liquids'
          : cards.length === 1
            ? 'Shop 10 for £8 e-liquids'
            : 'Shop £1.49 e-liquids - mix any 10 for £12');
      });
      cards.push(column);
    });

    if (cards.length) cards[0].parentElement.classList.add('vp-home-offer-grid');
  }

  function installStyles() {
    var oldStyle = document.getElementById(OLD_STYLE_ID);
    if (oldStyle) oldStyle.remove();

    var style = document.getElementById(STYLE_ID) || document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.vp-home-offer-card{--vp-offer-a:#9f1239;--vp-offer-b:#be123c;min-height:276px!important;padding:8px!important;}',
      '.vp-home-offer-card[data-vp-home-offer="2"]{--vp-offer-a:#075985;--vp-offer-b:#0e7490;}',
      '.vp-home-offer-card[data-vp-home-offer="3"]{--vp-offer-a:#6b21a8;--vp-offer-b:#9333ea;}',
      '.vp-home-offer-card>.yv-gallery-collage-item{height:260px!important;min-height:260px!important;border-radius:14px!important;overflow:hidden!important;box-shadow:0 10px 28px rgba(15,23,42,.28),inset 0 0 0 2px rgba(255,255,255,.38)!important;isolation:isolate;}',
      '.vp-home-offer-card>.yv-gallery-collage-item:after{content:"";position:absolute;inset:0;z-index:1;background:linear-gradient(135deg,var(--vp-offer-a),var(--vp-offer-b));opacity:.9;pointer-events:none;}',
      '.vp-home-offer-card .yv-gallery-collage-img,.vp-home-offer-card .image-wrapper,.vp-home-offer-card .yv-gallery-collage-img img,.vp-home-offer-card .yv-gallery-collage-detail-wrapper{height:260px!important;min-height:260px!important;}',
      '.vp-home-offer-card .image-wrapper{padding-bottom:0!important;}',
      '.vp-home-offer-card .yv-gallery-collage-img img{object-fit:cover!important;filter:saturate(1.25) contrast(1.08)!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail-wrapper{z-index:2!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail{position:absolute!important;inset:0!important;transform:none!important;width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;padding:24px!important;display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:12px!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail h3{max-width:100%!important;margin:0!important;color:#fff!important;font-size:clamp(2rem,2.6vw,3.4rem)!important;font-weight:900!important;line-height:1.04!important;letter-spacing:-.025em!important;text-align:center!important;text-wrap:balance;text-shadow:0 2px 5px rgba(0,0,0,.55)!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail p{margin:0!important;color:#fff!important;font-size:clamp(1rem,1.15vw,1.3rem)!important;font-weight:700!important;line-height:1.35!important;text-shadow:0 1px 3px rgba(0,0,0,.55)!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail a.button{min-width:210px!important;min-height:54px!important;margin:2px 0 0!important;padding:14px 28px!important;border:2px solid #111827!important;border-radius:999px!important;background:#facc15!important;color:#111827!important;font-size:1.05rem!important;font-weight:900!important;line-height:1.15!important;letter-spacing:.025em!important;box-shadow:0 5px 0 #111827,0 9px 20px rgba(0,0,0,.28)!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail a.button:hover,.vp-home-offer-card .yv-gallery-collage-detail a.button:focus-visible{background:#fde047!important;color:#111827!important;transform:translateY(-1px)!important;box-shadow:0 6px 0 #111827,0 11px 24px rgba(0,0,0,.32)!important;}',
      '.vp-home-offer-card .yv-gallery-collage-detail a.button:focus-visible{outline:3px solid #fff!important;outline-offset:3px!important;}',
      '@media (min-width:768px) and (max-width:991px){.vp-home-offer-card{flex:0 0 100%!important;max-width:100%!important;}}',
      '@media (max-width:767px){.vp-home-offer-card{min-height:232px!important;padding:6px 10px!important;}.vp-home-offer-card>.yv-gallery-collage-item,.vp-home-offer-card .yv-gallery-collage-img,.vp-home-offer-card .image-wrapper,.vp-home-offer-card .yv-gallery-collage-img img,.vp-home-offer-card .yv-gallery-collage-detail-wrapper{height:220px!important;min-height:220px!important;}.vp-home-offer-card .yv-gallery-collage-detail{padding:20px 18px!important;gap:10px!important;}.vp-home-offer-card .yv-gallery-collage-detail h3{font-size:clamp(1.75rem,8vw,2.25rem)!important;}.vp-home-offer-card .yv-gallery-collage-detail p{font-size:1rem!important;}.vp-home-offer-card .yv-gallery-collage-detail a.button{width:min(100%,300px)!important;min-width:0!important;min-height:50px!important;font-size:1rem!important;}}',
      '@media (max-width:360px){.vp-home-offer-card .yv-gallery-collage-detail{padding:16px 14px!important;gap:8px!important;}.vp-home-offer-card .yv-gallery-collage-detail h3{font-size:1.55rem!important;}.vp-home-offer-card .yv-gallery-collage-detail a.button{min-height:48px!important;padding:12px 18px!important;}}',
      '@media (prefers-reduced-motion:reduce){.vp-home-offer-card .yv-gallery-collage-detail a.button{transition:none!important;}}'
    ].join('');
    if (!style.parentNode) (document.head || document.documentElement).appendChild(style);
  }

  function run() {
    markOfferCards();
    installStyles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
  window.setTimeout(run, 400);
})();
